<template>
  <div :class="formClass">
    <p class="font-semibold">{{ title }}</p>
    <div :class="{ warn: isError }" class="relative">
      <textarea
        @input="$emit('update:modelValue', $event.target.value)"
        :value="modelValue"
        :class="[inputClass, { 'p-invalid': isError }]"
        class="p-inputtextarea p-inputtext p-component w-full"
        :placeholder="placeholder"
        :disabled="disabled"
        :rows="rows"
      ></textarea>
      <small v-if="isError" class="p-error">{{ error }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: "Input",
  inheritAttrs: false,
  emits: ["update:modelValue"],
  props: {
    modelValue: [String, Number],
    isError: Boolean,
    error: String,
    title: String,
    disabled: Boolean,
    placeholder: String,
    formClass: String,
    inputClass: String,
    rows: String,
  },
};
</script>
